export default __webpack_public_path__ + "static/media/arrow_down_disabled.03101e90.svg";